<header class="modal-header bg-white border-bottom-0">
    <h5>Dirección</h5>
    <button type="button" class="close" (click)="onCancelar()">
        <span aria-hidden="true">&times;</span>
    </button>
</header>
<section class="modal-body">
    <form [formGroup]="formDireccionBuilder">
        <!-- PRINCIPAL -->
        <div class="row">
            <div class="form-group col-12">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" formControlName="usaFormatoCompletoCtrl"
                        id="usaFormatoCompletoCtrl" />
                    <label for="usaFormatoCompletoCtrl">Usa formato completo?</label>
                </div>
            </div>
        </div>
        <div class="row mb-3">
            <div class="form-group col-5">
                <label for="pCalleCtrl" class="control-label required">Avenida/Calle</label>
                <select class="form-control" formControlName="pCalleCtrl" id="pCalleCtrl">
                    <option></option>
                    <option *ngFor="let opt of avenidas" [ngValue]="opt">{{opt.nombre_completo}}</option>
                </select>
                <p *ngIf="pCalleCtrl.hasError('required') && pCalleCtrl.touched" class="invalid-feedback">Requerido
                </p>
            </div>
            <div class="form-group col-3 col-sm-2">
                <label for="pNumeroCtrl" class="control-label required">No.</label>
                <input class="form-control" type="number" placeholder="00" formControlName="pNumeroCtrl"
                    id="pNumeroCtrl" maxlength="10" />
                <p *ngIf="pNumeroCtrl.hasError('required') && pNumeroCtrl.touched" class="invalid-feedback">Requerido
                </p>
                <p *ngIf="pNumeroCtrl.hasError('min') && pNumeroCtrl.touched" class="invalid-feedback">Inválido</p>
            </div>
            <div class="form-group col-4 col-sm-2">
                <label for="pLetraCtrl" class="control-label">Letra</label>
                <select class="form-control" formControlName="pLetraCtrl" id="pLetraCtrl">
                    <option></option>
                    <option *ngFor="let opt of letras" [ngValue]="opt">{{opt.nombre_completo}}</option>
                </select>
            </div>
            <div class="form-group col-5 col-sm-3">
                <label for="pOrientacionCtrl" class="control-label">Orientacion</label>
                <select class="form-control" formControlName="pOrientacionCtrl" id="pOrientacionCtrl">
                    <option></option>
                    <option *ngFor="let opt of orientaciones" [ngValue]="opt">{{opt.nombre_completo}}
                    </option>
                </select>
            </div>
        </div>

        <!-- SECUNDARIA -->
        <div class="row mb-3">
            <div class="form-group col-3 col-sm-2">
                <label for="s1NumeroCtrl" class="control-label required">No.</label>
                <input class="form-control" type="number" maxlength="10" placeholder="00" formControlName="s1NumeroCtrl"
                    id="s1NumeroCtrl" />
                <p *ngIf="s1NumeroCtrl.hasError('required') && s1NumeroCtrl.touched" class="invalid-feedback">Requerido
                </p>
                <p *ngIf="s1NumeroCtrl.hasError('min') && s1NumeroCtrl.touched" class="invalid-feedback">Inválido</p>
            </div>
            <div class="form-group col-4 col-sm-2">
                <label for="s1LetraCtrl" class="control-label">Letra</label>
                <select class="form-control" formControlName="s1LetraCtrl" id="s1LetraCtrl">
                    <option></option>
                    <option *ngFor="let opt of letras" [ngValue]="opt">{{opt.nombre_completo}}</option>
                </select>
            </div>
            <div class="form-group col-3">
                <label for="s1OrientacionCtrl" class="control-label">Orientación</label>
                <select class="form-control" formControlName="s1OrientacionCtrl" id="s1OrientacionCtrl">
                    <option></option>
                    <option *ngFor="let opt of orientaciones" [ngValue]="opt">{{opt.nombre_completo}}
                    </option>
                </select>
            </div>
            <div class="col-12"></div>
            <div class="form-group col-3 col-sm-2">
                <input class="form-control" type="number" maxlength="10" placeholder="00"
                    formControlName="s2NumeroCtrl" />
                <p *ngIf="s2NumeroCtrl.hasError('required') && s2NumeroCtrl.touched" class="invalid-feedback">Requerido
                </p>
                <p *ngIf="s2NumeroCtrl.hasError('min') && s2NumeroCtrl.touched" class="invalid-feedback">Inválido</p>
            </div>
            <div class="form-group col-4 col-sm-2">
                <select class="form-control" formControlName="s2LetraCtrl">
                    <option></option>
                    <option *ngFor="let opt of letras" [ngValue]="opt">{{opt.nombre_completo}}</option>
                </select>
            </div>
            <div class="form-group col-3">
                <select class="form-control" formControlName="s2OrientacionCtrl">
                    <option></option>
                    <option *ngFor="let opt of orientaciones" [ngValue]="opt">{{opt.nombre_completo}}
                    </option>
                </select>
            </div>
        </div>

        <!-- ADICIONAL -->
        <div class="row mb-3">
            <label class="col-12 control-label">Información adicional</label>
            <div class="form-group col-6">
                <select class="form-control" formControlName="a1AbreviaturaCtrl">
                    <option></option>
                    <option *ngFor="let opt of adicionales" [ngValue]="opt">{{opt.nombre_completo}}
                    </option>
                </select>
            </div>
            <div class="form-group col-6">
                <input class="form-control" type="text" maxlength="255" placeholder="" formControlName="a1ValorCtrl" />
            </div>
            <div class="form-group col-6">
                <select class="form-control" formControlName="a2AbreviaturaCtrl">
                    <option></option>
                    <option *ngFor="let opt of adicionales" [ngValue]="opt">{{opt.nombre_completo}}
                    </option>
                </select>
            </div>
            <div class="form-group col-6">
                <input class="form-control" type="text" maxlength="255" placeholder="" formControlName="a2ValorCtrl" />
            </div>
            <div class="form-group col-6">
                <select class="form-control" formControlName="a3AbreviaturaCtrl">
                    <option></option>
                    <option *ngFor="let opt of adicionales" [ngValue]="opt">{{opt.nombre_completo}}
                    </option>
                </select>
            </div>
            <div class="form-group col-6">
                <input class="form-control" type="text" maxlength="255" placeholder="" formControlName="a3ValorCtrl" />
            </div>
            <div class="form-group col-6">
                <select class="form-control" formControlName="a4AbreviaturaCtrl">
                    <option></option>
                    <option *ngFor="let opt of adicionales" [ngValue]="opt">{{opt.nombre_completo}}
                    </option>
                </select>
            </div>
            <div class="form-group col-6">
                <input class="form-control" type="text" maxlength="255" placeholder="" formControlName="a4ValorCtrl" />
            </div>

            <!-- NO ESTRUCTURADA -->
            <div class="form-group col-12">
                <label class="control-label" for="direccionNoEstructuradaCtrl">Dirección no estructurada</label>
                <input class="form-control" type="text" max="512" placeholder=""
                    formControlName="direccionNoEstructuradaCtrl" id="direccionNoEstructuradaCtrl" />
            </div>
        </div>
    </form>
    <hr>

    <form [formGroup]="formDireccion">
        <div class="row mb-3">
            <div class="form-group col-12">
                <label class="control-label">Dirección</label>
                <textarea class="form-control" formControlName="direccionCtrl" readonly></textarea>
            </div>
        </div>
    </form>
</section>
<footer class="modal-footer">
    <button class="btn" (click)="onCancelar()">
        Cancelar
    </button>
    <button class="btn btn-primary" (click)="onConfirmar()" [disabled]="!formDireccion.valid">
        Aceptar
    </button>
</footer>